import { InjectionToken } from '@angular/core';

export const WEB_COMPONENT_DEFAULT_URL: InjectionToken<string>
  = new InjectionToken<string>('Used for initial routing inside web-component');
